import type {CaseReducer, PayloadAction} from '@reduxjs/toolkit'

import type {NotificationDto} from '../../services/pipelinesApi.types'

import type {PipelineDraftState} from './EditPipelinePage.slices.types'
import {
  deleteIfEmpty,
  ensurePipelineDraftEntry,
  getPipelineDraftEntry,
} from './EditPipelinePage.slices.utils'

export const addNotification: CaseReducer<
  PipelineDraftState,
  PayloadAction<{id: string; notification: NotificationDto; branch: string}>
> = (state, action) => {
  const notification = action.payload.notification
  const id = action.payload.id ?? 0
  const branch = action.payload.branch
  const pipeline = getPipelineDraftEntry(state, id, branch)
  const {draft} = pipeline ?? {}
  const notificationId: number = draft?.notifications ? draft.notifications.length - 1 : 0

  if (draft != null) {
    draft.notifications ??= []
    draft.notifications.push(notification)
    pipeline!.added ??= {}
    pipeline!.added!.notifications ??= {}
    pipeline!.added!.notifications![notificationId] = true
  }
}

export const updateNotification: CaseReducer<
  PipelineDraftState,
  PayloadAction<{
    id: string
    notificationId: string
    notificationData: Partial<NotificationDto>
    branch: string
  }>
> = (state, action) => {
  const {id, notificationId, notificationData, branch} = action.payload
  const notifications = getPipelineDraftEntry(state, id, branch)?.draft?.notifications ?? []
  if (notifications && notificationId) {
    const notificationIndex = notificationId ? Number(notificationId) : -1
    if (notificationIndex !== -1) {
      notifications[notificationIndex] = {
        ...notifications[notificationIndex],
        ...notificationData,
      }
    }
  }
}

export const deleteNotification: CaseReducer<
  PipelineDraftState,
  PayloadAction<{
    id: string
    notificationId: string
    branch: string
  }>
> = (state, action) => {
  const {id, notificationId, branch} = action.payload

  const pipeline = ensurePipelineDraftEntry(state, id, branch)
  pipeline.deleted ??= {}
  pipeline.deleted!.notifications ??= []
  pipeline.deleted!.notifications.push(notificationId)
}

export const restoreNotification: CaseReducer<
  PipelineDraftState,
  PayloadAction<{
    id: string
    notificationId: string
    branch: string
  }>
> = (state, action) => {
  const {id, notificationId, branch} = action.payload
  const deleted = getPipelineDraftEntry(state, id, branch)?.deleted?.notifications
  if (deleted?.includes(notificationId)) {
    deleted.splice(
      deleted.findIndex(n => n === notificationId),
      1,
    )

    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    deleteIfEmpty(getPipelineDraftEntry(state, id, branch)!.deleted, 'notifications') &&
      deleteIfEmpty(getPipelineDraftEntry(state, id, branch), 'deleted')
  }
}
